import React from "react";
import { Bookmark } from "./Bookmark";
import { useAppContext } from "../../Contexts/AppContext";

export const BookmarkList = (): JSX.Element => {
    const { bookmarks } = useAppContext();

    return (
        <div>
            {bookmarks.map((b) => (
                <Bookmark key={"bookmark" + b.id} bookmark={b} />
            ))}
        </div>
    );
};
